export enum Console {
  Backup = 'backup',
  GlobalManagement = 'global-management',
  DataEngine = 'data-engine',
}

const GLOBAL_MANAGEMENT_PREFIX = '/global-management';
const DATA_ENGINE_PREFIX = '/data-engine';

export const consoleForPathname = (pathname: string): Console => {
  if (pathname.startsWith(GLOBAL_MANAGEMENT_PREFIX)) {
    return Console.GlobalManagement;
  }
  if (pathname.startsWith(DATA_ENGINE_PREFIX)) {
    return Console.DataEngine;
  }
  return Console.Backup;
};

export const backupLandingPath = (saasInventoryDefaultLanding: boolean) =>
  saasInventoryDefaultLanding ? '/saas-inventory' : '/inventory';

// Backup gets an explicit path rather than '/', which resolves to the account's default console and may not be Backup.
export const consoleLandingPath = (
  target: Console,
  saasInventoryDefaultLanding: boolean
): string => {
  switch (target) {
    case Console.GlobalManagement:
      return '/global-management';
    case Console.DataEngine:
      return '/data-engine';
    default:
      return backupLandingPath(saasInventoryDefaultLanding);
  }
};
